{
  "on": "su",
  "none": "Nessuno",
  "device": "apparato | apparato | apparati",
  "operation": "operazione | operazione | operazioni",
  "profile": "profilo | profilo | profili",
  "application": "applicazione | applicazione | applicazioni",
  "campaign": "campagna | campagna | campagne",
  "user": "utente | utente | utenti",
  "group": "gruppo | gruppo | gruppi",
  "userGroup": "gruppo utenti | gruppo utenti | gruppi utenti",
  "firmware": "firmware | firmware | firmware",
  "applicationMgt": "applicazione | applicazione |applicazioni",
  "dtwins": "apparato | apparato | apparati"
}
